import SVGComponent from '../../Component/components/SVGComponent';
import '../Image/FlipImage.svelte';
import SvgColor from './SVGColor.svelte';
export default class SVGModule {
    validComponents = [SVGComponent];
    toolbarActions = [
        {
            component: SvgColor,
            props: {
                desc: 'test'
            }
        }
        // {component: FlipImage}
    ];
}
